export const zIndexes = {
  bottomsheet: 100,
  modal: 1000,
  bottomSheetOverModal: 1010,
  dropdown: 10000,
  tooltip: 100000,
}
